import React, { useEffect, useState } from "react";

import BillTab from "../Wallet/BillTab";

const RecentTransactions = (props) => {
  return (
    <React.Fragment>
      <div className="card shadow-sm mb-4">
        <div className="card-body">
          <h5 className="card-title">Bill Payment History</h5>

          <BillTab hideLoading={true} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default RecentTransactions;
